// Environment configuration
// This file is imported early in the app to make environment variables available globally

// Register global environment variables
window.appMode = process.env.APP_MODE || 'development';
window.apiEndPoint = process.env.API_ENDPOINT || 'http://api.local.kevi.io/';
window.baseUrl = process.env.BASE_URL || 'http://app.local.kevi.io/';
window.mixpanelAppId = process.env.MIXPANEL_APP_ID || '';
window.gtmId = process.env.GTM_ID || '';
window.rewardsUrl = process.env.REWARDS_URL || 'http://localhost:3001';
window.rewardsDomain = process.env.REWARDS_DOMAIN || '';

// Also make them available as a config object for easier access
window.appConfig = {
  mode: window.appMode,
  apiEndpoint: window.apiEndPoint,
  baseUrl: window.baseUrl,
  mixpanelAppId: window.mixpanelAppId,
  gtmId: window.gtmId,
  rewardsUrl: window.rewardsUrl,
  rewardsDomain: window.rewardsDomain
};
